var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tk-detail-photo"},_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"tk-detail-photo-item"},[_c('div',{staticClass:"tk-detail-photo-item-box",style:({
					'background-image':("url(" + (item.src) + ")")
				}),on:{"click":function($event){_vm.toBigger(index)}}})])}))}
var staticRenderFns = []

export { render, staticRenderFns }